import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
/**
 * @deprecated Use catch
 */
export interface ICustomResponse<T> {
  result: T;
  error: any;
}

/**
 *
 */
export function customResponse<T>(): (sourceObservable$: Observable<T>) => Observable<ICustomResponse<T>> {
  return (source$: Observable<T>): Observable<ICustomResponse<T>> =>
    source$.pipe(
      map(r => ({ result: r, error: undefined })), //
      catchError(error => {
        console.error('Error loading', error);
        return of({ error: error, result: undefined });
      }),
      startWith({ result: undefined, error: undefined })
    );
}
